module.exports = __webpack_public_path__ + "static/media/bg-prod.e10efac9.png";